import _extends from "@babel/runtime/helpers/extends";
/*
 *                     NOTICE
 *            COPYRIGHT 2019 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { AbBusyIndicator as AbBusyIndicatorImpl, BusyIndicatorSize } from "abreact/progress/AbBusyIndicator";
import * as React from "react";

/**
 * The possible sizes for a busy indicator.
 */
export let AbBusyIndicatorSize = /*#__PURE__*/function (AbBusyIndicatorSize) {
  AbBusyIndicatorSize["CUSTOM"] = "custom";
  AbBusyIndicatorSize["TINY"] = "tiny";
  AbBusyIndicatorSize["SMALL"] = "small";
  AbBusyIndicatorSize["LARGE"] = "large";
  return AbBusyIndicatorSize;
}({});

/**
 * Properties of the AbBusyIndicator component.
 */

/**
 * The **AbBusyIndicator** component is a visual indicator used to signify that a portion of the application is busy.
 *
 * [[include:absdk/commons/ui/misc/AbBusyIndicator.md]]
 */
export class AbBusyIndicator extends React.Component {
  static mapBusyIndicatorSize(size) {
    switch (size) {
      case AbBusyIndicatorSize.CUSTOM:
        {
          return BusyIndicatorSize.CUSTOM;
        }
      case AbBusyIndicatorSize.TINY:
        {
          return BusyIndicatorSize.TINY;
        }
      case AbBusyIndicatorSize.SMALL:
        {
          return BusyIndicatorSize.SMALL;
        }
      case AbBusyIndicatorSize.LARGE:
        {
          return BusyIndicatorSize.LARGE;
        }
    }
    throw new Error(`Unexpected busy indicator size ${size}`);
  }
  render() {
    return /*#__PURE__*/React.createElement(AbBusyIndicatorImpl, _extends({}, this.props, {
      size: this.props.size ? AbBusyIndicator.mapBusyIndicatorSize(this.props.size) : undefined
    }));
  }
}
//# sourceMappingURL=AbBusyIndicator.js.map
